import React from 'react';
import { I18n } from '@aws-amplify/core';
import { Row, Col, Radio, RadioChangeEvent } from 'antd';
import { useCategoryContext } from './context';
import { InfoTooltip } from '../../../../components/InfoTooltip';
import { RosaCategoryEnum, RosaSubCategoryEnum } from '../../constants';
import { useRosaContext } from '@/components/views/Report/Rosa/context';
import { useUpdateDuration } from '@/components/views/Report/Rosa/hooks/useUpdateDuration';
import { RadioGroup, ScoresContainer } from './SubCategorySection/Duration/styles';
import { FormItem } from '../../styles';
import * as S from './styles';

export function Duration() {
	const {
		category: { sub_categories }
	} = useCategoryContext();
	const { organization_id, company_id, file_id } = useRosaContext();

	const subCategory = sub_categories.find((item) => item.name === 'seat_backrest');
	const fieldName = ['evaluation', RosaCategoryEnum.CHAIR, RosaSubCategoryEnum.SEAT_BACKREST];

	const { mutate: updateDuration } = useUpdateDuration({
		organization_id,
		company_id,
		report_id: file_id,
		sub_category_id: subCategory?.id
	});

	function handleOnChange(e: RadioChangeEvent): void {
		const duration = e.target.value;
		updateDuration({ duration });
	}

	return (
		<Row>
			<Col span={24}>
				<Row justify="end" align="middle" gutter={[0, 20]}>
					<Col span={10}>
						<Row align="middle" gutter={[10, 0]} justify="end">
							<S.Label lg={10} xxl={10}>
								<S.StyledTitle level={5}>
									{I18n.get('Duration')} ({I18n.get('chair')})
								</S.StyledTitle>
								<S.TooltipContainer>
									<InfoTooltip />
								</S.TooltipContainer>
							</S.Label>
							<Col span={14}>
								<ScoresContainer>
									<FormItem name={[...fieldName, 'duration']}>
										<RadioGroup onChange={handleOnChange}>
											<Radio.Button value={-1}>-1</Radio.Button>
											<Radio.Button value={0}>0</Radio.Button>
											<Radio.Button value={1}>+1</Radio.Button>
										</RadioGroup>
									</FormItem>
								</ScoresContainer>
							</Col>
						</Row>
					</Col>
				</Row>
			</Col>
		</Row>
	);
}
